import { ComponentConfig } from '@measured/puck';

import { Badge } from '../../../../../components/atoms/badge/badge';
import { Indicator } from '../../../../../components/atoms/indicator/indicator';
import { Text } from '../../../../../components/atoms/text/text';
import { useAllIndicators } from '../../../context/indicators';

const IndicatorsKey = () => {
  const indicators = useAllIndicators();
  return (
    <ul className="my-2 flex items-center gap-2.5">
      {indicators.map((indicator, index) => {
        const completedOn = indicator.completedAt ? new Date(indicator.completedAt).toLocaleDateString() : null;

        return (
          <li className="inline-flex items-center gap-2.5" key={indicator.respondentType}>
            <Indicator appearance={indicator.disabled ? 'secondary' : indicator.indicatorAppearance} className="mr-0">
              {indicator.shortLabel}
            </Indicator>
            <Badge appearance={indicator.disabled ? 'secondary' : indicator.appearance}>
              {indicator.label}
              {indicator.disabled ? ' - Not referred' : ''}
            </Badge>
            {completedOn ? (
              <Text className="inline" tag="p">
                Completed on {completedOn}
              </Text>
            ) : null}
            {index < indicators.length - 1 ? <span>|</span> : null}
          </li>
        );
      })}
    </ul>
  );
};

const IndicatorsKeyBlock: ComponentConfig = {
  label: 'Respondent Indicators',
  fields: {},
  defaultProps: {},
  render: () => {
    return <IndicatorsKey />;
  },
};

export { IndicatorsKeyBlock };
